import { useLocation } from "react-router-dom";
import UserModeToggle from "@/components/UserModeToggle";
import CoachModeToggle from "@/components/CoachModeToggle";
import { useAuth } from "@/context/AuthContext";
import { useUserMode } from "@/context/UserModeContext";

// Single place to switch Simple / Full mode — sits at the foot of every page.
export function ModeSwitchFooter() {
  const { user } = useAuth();
  const { isSimple } = useUserMode();
  const { pathname } = useLocation();
  if (!user) return null;
  // Simple home launchers already render their own bottom switch.
  const onLauncher = pathname === "/dashboard"
    && ((user.role === "student" && isSimple) || (user.role !== "student" && user.simplified_mode === true));
  if (onLauncher) return null;
  return (
    <div className="mt-12 pt-6 border-t flex justify-center gap-2" style={{ borderColor: "var(--border, #262626)" }} data-testid="mode-switch-footer">
      <UserModeToggle compact noHome />
      <CoachModeToggle compact />
    </div>
  );
}
